import {forwardRef} from 'react';
import type {LinkProps} from 'react-router-dom';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps
} from 'react-router-dom';
import {Link} from '@mui/material';

interface PWMLinkProps extends Omit<LinkProps, 'to'> {
}

/**
 * This is an adapted for `react-router-dom/link` component.
 * We use this to help us maintain consistency between CRA and Next.js
 */
export const PWMLink = (props: PWMLinkProps) => {
  const {href, ...rest} = props;
  return (
    <Link
      component={ForwardRouterLink}
      href={href}
      underline="hover"
      variant="subtitle2"
      {...rest}
    >
      {props.children}
    </Link>
  )
};

interface PWMLinkProps {
  children?: any;
  href?: string;
}

export const ForwardRouterLink = forwardRef<any, Omit<RouterLinkProps, 'to'> & PWMLinkProps>((props: any, ref: any) => {
  const {href, ...other} = props;

  return (
    <RouterLink
      ref={ref}
      to={href}
      {...other}
    />
  );
});